import React from "react";
import "./header.scss"

export default function Header() {
  return (
    <div id={"header"}>
      <h1>Felix Epper | Anagramme</h1>
    </div>
  )
}